import axios from "axios";
import { download } from "fe-shared/src/helpers/files";
import { CorrectionsFormContent, Transaction } from "../../../types";
import { waitForBatchToBeFinished } from "../../../helpers/waitForBatchToBeFinished";

const isSubmitted = async (transactionNumber: string): Promise<boolean> => {
  return axios
    .get("corrections", { params: { transactionNumber } })
    .then(({ data }) => data.isSubmitted);
};

export const submitCorrections = async (
  transaction: Transaction,
  corrections: CorrectionsFormContent
): Promise<unknown> => {
  const { transactionNumber, transactionId } = transaction;

  const mappedCorrections = Object.keys(corrections).reduce((acc, item) => {
    const isEmptyData =
      !corrections[item] ||
      (Array.isArray(corrections[item]) && !corrections[item].length);

    if (!isEmptyData) {
      acc[item] =
        item === "attachments"
          ? corrections[item].map((file) => ({
              path: file.path,
              name: file.name,
              description: file.description,
            }))
          : corrections[item];
    }

    return acc;
  }, {} as CorrectionsFormContent);

  const resp = await axios
    .post("/corrections", { transactionNumber, ...mappedCorrections })
    .then((res) => res.data);

  const waitForBatch = await isSubmitted(transactionNumber);

  if (waitForBatch) {
    await waitForBatchToBeFinished(transactionId, Date.now());
  }

  return resp;
};

export const downloadFile = (path: string, fileName: string) =>
  axios
    .get(path, {
      responseType: "blob",
    })
    .then((res) => download(fileName, res));

export default submitCorrections;
